var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23.1667C16.8778 23.1667 17.1947 23.0387 17.4507 22.7827C17.7067 22.5267 17.8342 22.2102 17.8333 21.8333C17.8333 21.4556 17.7053 21.1391 17.4493 20.884C17.1933 20.6289 16.8769 20.5009 16.5 20.5C16.1222 20.5 15.8058 20.628 15.5507 20.884C15.2956 21.14 15.1676 21.4564 15.1667 21.8333C15.1667 22.2111 15.2947 22.528 15.5507 22.784C15.8067 23.04 16.1231 23.1676 16.5 23.1667ZM15.1667 17.8333H17.8333V9.83333H15.1667V17.8333ZM11.5 28.5L4.5 21.5V11.5L11.5 4.5H21.5L28.5 11.5V21.5L21.5 28.5H11.5ZM12.6333 25.8333H20.3667L25.8333 20.3667V12.6333L20.3667 7.16667H12.6333L7.16667 12.6333V20.3667L12.6333 25.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.ff6a2f3722af4f6f29c182e031de7ece.svg";
export { ForwardRef as ReactComponent };